import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const searchMaps = async ({
  coords,
  feedType = 'all',
  from = 0,
  query = '',
  size = 10,
  tagIds
}) => {
  const response = await API.graphql({
    query: SEARCH_MAPS_QUERY,
    variables: {
      coords,
      feedType,
      from,
      query,
      size,
      tagIds
    },
    authMode: 'API_KEY'
  })
  return response?.data
}

const SEARCH_MAPS_QUERY = gql`
  query SearchMaps(
    $coords: Coordinates
    $feedType: FEED_TYPES!
    $from: Int
    $query: String
    $size: Int
    $tagIds: [String!]
  ) {
    searchMaps(
      coords: $coords
      feedType: $feedType
      from: $from
      query: $query
      size: $size
      tagIds: $tagIds
    ) {
      total
      items {
        id
        dataId
        name
        description
        likes
        views
        liked
        dataReady
        createdAt
        bbox
        properties {
          name
          type
          isTitle
          isPercentage
          isDefaultVisualisation
          isAggregate
          visualisation
        }
        workspace {
          id
          name
          description
          logo
          createdAt
          inviteId
        }
        mapTagCollection {
          total
          items {
            tag {
              id
              name
              description
              type
              count
            }
          }
        }
      }
    }
  }
`

export { searchMaps, SEARCH_MAPS_QUERY }
export default searchMaps
